import { Component, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CadService } from '../../../Services/CADServices/cad.service';
import { BServiceService } from '../../../Services/BService/b-service.service';
import { BSharedServiceService } from '../../../Services/BService/b-shared-service.service';
import { v4 as uuidv4 } from 'uuid';
import { MatDialog } from '@angular/material/dialog';
import { ImagePopUpComponent } from '../image-pop-up/image-pop-up.component';
import { PdfDialogComponent } from '../../pdf-dialog/pdf-dialog.component';
import { SharedDataService } from '../../../Services/SharedServices/shared-data.service';
import { environment } from '../../../../Environment/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-b-second-selection',
  templateUrl: './b-second-selection.component.html',
  styleUrl: './b-second-selection.component.css'
})
export class BSecondSelectionComponent {
  AssetbasePath:any;
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  constructor(private sharedDataService: SharedDataService, public dialog: MatDialog,private formBuilder:FormBuilder,private cadService: CadService, private bservice:BServiceService, private bSharedService:BSharedServiceService,private router: Router) {
    this.AssetbasePath = environment.assetsPath;
  }
  formSubmitted = false;
  inputUnitVersion:any;
  inputType:any;
  inputOutputShaft:any;
  inputMotorAdaptor:any;
  inputMountingPosition:any;
  inputPrimaryMountingPosition:any;
  inputSpecialFeature:any;
  productCode:any;
  finalData:any={
    location:"",
    code:""
  };
  CADfileFormat={
    CAD2DFileFormat:'.dxf',
    CAD3DFileFormat:'.stp',
  };
  reducerSelectionForm = this.formBuilder.group({
    inputUnitVersion:[null, Validators.required],
    inputType:[null, Validators.required],
    inputOutputShaft:[null, Validators.required],
    inputAssemblyPosition:[null,Validators.required],
    inputMotorAdaptor:[null,Validators.required],
    inputMountingPosition:[null,Validators.required],
    inputSpecialFeature:[null,Validators.required],
  });
  assembleCode={
    series:"B",
    size:"",
    // revision:"5",
    reduction:"1",
    revision:"1",
    ratio:"",
    untiversion:"",
    inputType:"",
    outputshaft:"",
    motorAdaptor:"",
    mountingPosition:"",
    primaryMountingPosition:"",
    specialfeature:""
};
public showspinfo: boolean = false;
  public showcdinfo: boolean = false;
size:any;
  ratio:any;
  speed:any;
  specData:any={};
  ngOnInit(){
    const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
    this.bSharedService.specification$.subscribe((specificationData:any) => 
      {
        this.specData= specificationData;
        console.log("I am in Data", this.specData);
      });
    this.bSharedService.size$.subscribe((sizeData:any) => 
      {
        // this.size = sizeData.size.replace(/[a-zA-Z]/g, '');
        console.log("Data of set size rato and speed", sizeData);
        this.size = sizeData.size;
        this.ratio = sizeData.ratio;
        this.speed = sizeData.speed;
        this.assembleCode.size = sizeData.size;
        this.assembleCode.ratio = sizeData.ratio;
        // this.assembleCode.inputspeed = sizeData.speed;
        this.getUnitVersion();
      });
    
  }
  onUnitVersionChange(event:any){
    this.assembleCode.untiversion = event.target.value;
    this.getInputType();
    this.resetDependentDropdowns(['inputType']);
  }
  onInputTypeChange(event:any){
    debugger;
    this.assembleCode.inputType = event.target.value;
    this.getOutputShaft(this.size);
    this.resetDependentDropdowns(['inputOutputShaft']);
  }
  oninputOutputShaftChange(event:any){
    this.assembleCode.outputshaft = event.target.value;
    const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement;
    if(this.assembleCode.inputType=="R"){
      motorAdaptor.disabled = true;
      this.resetDependentDropdowns(['inputMotorAdaptor']);
      this.assembleCode.motorAdaptor = "-";
      this.getMountingPosition(this.assembleCode.untiversion, this.assembleCode.outputshaft);
      this.resetDependentDropdowns(['inputMountingPosition']);
      this.reducerSelectionForm.get('inputMotorAdaptor')?.clearValidators();
  this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
    }else{
      if(motorAdaptor.disabled == true){
        motorAdaptor.disabled = false;
        this.assembleCode.motorAdaptor = "";
      }
      this.getMotorAdaptor(this.size, this.assembleCode.inputType);
      this.resetDependentDropdowns(['inputMotorAdaptor']);
    }
    
  }
  oninputMotorAdaptorChange(event:any){
    this.assembleCode.motorAdaptor = event.target.value;
    this.getMountingPosition(this.assembleCode.untiversion, this.assembleCode.outputshaft);
    this.resetDependentDropdowns(['inputMountingPosition']);
  }
  oninputMountingPositionChange(event:any){
    this.assembleCode.mountingPosition = event.target.value;
    this.getFeatures("1", this.assembleCode.outputshaft, this.assembleCode.inputType);
    this.resetDependentDropdowns(['inputSpecialFeature']);
  }
  oninputSpecialFeatureChange(event:any){
    this.assembleCode.specialfeature = event.target.value;
     }
  private getUnitVersion():void{
    this.signalStatus=true;
  this.panelOpenState = signal(this.signalStatus);
    this.bservice.getUnitVersion().subscribe(result=>{
       this.inputUnitVersion = Object.keys(result).map(key => ({
         key: key,
         value: result[key]
       }));
       console.log("Unit Version", this.inputUnitVersion);
    },
   (error)=>{
     console.error('Error fetching in unitversion :', error);
   });
   }
   private getInputType():void{
    const rgImage = document.getElementById('rgImage') as HTMLInputElement;
    rgImage.src = this.AssetbasePath+"/Content/BImages/TypeOfUnit.gif";
    this.bservice.getInputType().subscribe(result=>{
      this.inputType = Object.keys(result).map(key => ({
        key: key,
        value: result[key]
      }));
      console.log("Input Type", result);
    },
    (error)=>{
      console.error('Error fetching in type of unit :', error);
    });
  }
  private getOutputShaft(size:any):void{
    const rgImage = document.getElementById('rgImage') as HTMLInputElement;
    rgImage.src = this.AssetbasePath+"/Content/BImages/OutputShaft.gif";
    this.bservice.getOutputShaft(size).subscribe(result=>{
      this.inputOutputShaft = Object.keys(result).map(key => ({
        key: key,
        value: result[key]
      }));
      console.log("Output Shaft", result);
    },
    (error)=>{
      console.error('Error fetching in Output Shaft :', error);
    });
  }
  private getMotorAdaptor(size:any, typeOfUnit:any):void{
    const rgImage = document.getElementById('rgImage') as HTMLInputElement;
    rgImage.src = this.AssetbasePath+"/Content/BImages/MotorAdaptors.gif";
    this.bservice.getMotorAdaptor(size,typeOfUnit).subscribe(result=>{
      this.inputMotorAdaptor = Object.keys(result).map(key => ({
        key: key,
        value: result[key]
      }));
      console.log("Motor Adaptor", result);
    },
    (error)=>{
      console.error('Error fetching in Motor Adaptor :', error);
    });
  }
  openDialog(pdfSrc: string){
    if(pdfSrc.includes('mountingPosition.gif')){
      this.dialog.open(ImagePopUpComponent)
    }
    
  }
  viewPDF(pdfSrc: string) {
    
    if(pdfSrc.includes('mountingPosition.gif')){
      debugger;
      pdfSrc = this.AssetbasePath+"/Content/BImages/MountingPositionpdf.pdf";
      this.dialog.open(PdfDialogComponent, {
        data: { pdfSrc: pdfSrc }
      });
    }
  }
  private getMountingPosition(unitversion:string, outputshaft:string):void{
    debugger;
    const rgImage = document.getElementById('rgImage') as HTMLInputElement;
    rgImage.src = this.AssetbasePath+"/Content/BImages/mountingPosition.gif";
    if(rgImage.src.includes('mountingPosition.gif')){
      // rgImage.addEventListener('click', this.openDialog.bind(this));
    // rgImage.addEventListener('click', this.viewPDF.bind(this,'../assets/Content/BImages/MountingPositionpdf.pdf'));
    }
    
    this.bservice.getMountingPosition(unitversion, outputshaft).subscribe(result=>{
      this.inputMountingPosition = Object.keys(result).map(key => ({
        key: key,
        value: result[key]
      }));
      console.log("Mounting Position", result);
    },
    (error)=>{
      console.error('Error fetching in Mounting Position :', error);
    });
  }
  // private getPrimaryMountingPosition(reduction:string,typeofunit:string):void{
  //   const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  //   rgImage.src = "./assets/Content/HPAImages/Col11.png";
  //   this.bservice.getPrimaryMountingPosition(reduction, typeofunit).subscribe(result=>{
  //     this.inputPrimaryMountingPosition = Object.keys(result).map(key => ({
  //       key: key,
  //       value: result[key]
  //     }));
  //     console.log("Primary Mounting Position", result);
  //   },
  //   (error)=>{
  //     console.error('Error fetching in Primary Mounting Position :', error);
  //   });
  // }
  private getFeatures(reduction:any,outputShaft:any, typeOfUnit:any):void{
    const rgImage = document.getElementById('rgImage') as HTMLInputElement;
    
    rgImage.src = this.AssetbasePath+"/Content/BImages/SPL_Features.jpg";
    this.bservice.getFeatures(reduction,outputShaft,typeOfUnit).subscribe(result=>{
      this.inputSpecialFeature = Object.keys(result).map(key => ({
        key: key,
        value: result[key]
      }));
      console.log("Special Features", result);
    },
    (error)=>{
      console.error('Error fetching in Special Features :', error);
    });
  }
  private resetDependentDropdowns(dropdownNames: string[]) {
    dropdownNames.forEach(name => {
      this.reducerSelectionForm.get(name)?.reset();
    });
  }
  rgReducerButton(){
    debugger;
    this.formSubmitted = true;
    this.productCode = this.assembleCode.series+this.assembleCode.size.substring(1,3) + this.assembleCode.reduction + this.assembleCode.revision + this.assembleCode.ratio + this.assembleCode.untiversion + this.assembleCode.inputType + this.assembleCode.outputshaft + this.assembleCode.motorAdaptor + this.assembleCode.mountingPosition + "-" + this.assembleCode.specialfeature; 
    console.log("Product Code is: ", this.productCode);
    this.bSharedService.setProductCode(this.productCode);
    this.sharedDataService.setCADChangeStatus("true");
    this.getAllproductDetail();
    this.getKits();
    this.createCAD();
  }
  createCAD():void {
    debugger;
    const cadData={
      Website:"Series-B",
      Guid: uuidv4(),
      Code:this.productCode.toString().trim(),
      asmFormat:this.CADfileFormat.CAD3DFileFormat.toString().trim(),
      dwgFormat:this.CADfileFormat.CAD2DFileFormat.toString().trim(),
      MotorFrame: "",
      FlangType:"",
      ShaftDia:"",
      TimeIn:this.getCurrentFormattedDate(),
      ClientIP:"10.248.24.1"
    };
    debugger;
    // this.finalData.cadLocation = cadData.Guid;
    this.finalData.location = cadData.Guid;
    this.finalData.code = cadData.Code;
    this.bSharedService.setCadData(this.finalData);
    this.cadService.GenerateCADLoadbalancing(cadData);
  
    }
  
  getCurrentFormattedDate(): string {
    const now = new Date();
  
    // Helper function to pad single-digit numbers with leading zero
    const dateData = (num: number) => num.toString().padStart(2, '0');
  
    return `${now.getFullYear()}-${dateData(now.getMonth() + 1)}-${dateData(now.getDate())}T${dateData(now.getHours())}:${dateData(now.getMinutes())}:${dateData(now.getSeconds())}`;
  }
  
  getAllproductDetail(){
    const unitversion = document.getElementById("inputUnitVersion") as HTMLSelectElement;
    const typeOfUnit = document.getElementById("inputType") as HTMLSelectElement;
    const OutputShaft = document.getElementById("inputOutputShaft") as HTMLSelectElement;
    const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLSelectElement;
    const mountingPosition = document.getElementById("inputMountingPosition") as HTMLSelectElement;
    const specialFeature = document.getElementById("inputSpecialFeature") as HTMLSelectElement;
    const prodDetails={
      size:this.assembleCode.size,
      ratio: this.assembleCode.ratio,
      unitversion: unitversion.options[unitversion.selectedIndex].text.replace(/^.*? - /, ''),
      unitversionValue:unitversion.value,
      typeOfUnit: typeOfUnit.options[typeOfUnit.selectedIndex].text.replace(/^.*? - /, ''),
      typeOfUnitValue: typeOfUnit.value,
      OutputShaft: OutputShaft.options[OutputShaft.selectedIndex].text.replace(/^.*? - /, ''),
      OutputShaftValue: OutputShaft.value,
      motorAdaptor: motorAdaptor.options[motorAdaptor.selectedIndex].text.replace(/^.*? - /, ''),
      motorAdaptorValue:motorAdaptor.value,
      mountingPosition: mountingPosition.options[mountingPosition.selectedIndex].text,
      mountingPositionValue:mountingPosition.value,
      specialFeature: specialFeature.options[specialFeature.selectedIndex].text.replace(/^.*? - /, ''),
      specialFeatureValue:specialFeature.value,
      // speed:this.assembleCode.inputspeed,
    };
    this.bSharedService.setProductSpecification(prodDetails);
   }












   getKits():void{
    const parameters={
      size:this.assembleCode.size,
      typeOfUnit:this.assembleCode.inputType,
      unitVersion:this.assembleCode.untiversion,
      outputShaft : this.assembleCode.outputshaft,
      specialFeature: this.assembleCode.specialfeature,
      ratio: this.assembleCode.ratio,
      motorAdaptor: this.assembleCode.motorAdaptor
    };
    this.bservice.getKits(parameters).subscribe(result => {
      console.log("Kits Data", result);
          if(result.body==null){
        alert("No Kits available")
      }else
      {
        this.bSharedService.setKits(result.body);
      }
    });
  
  }




   
}
